export default __webpack_public_path__ + "static/media/handHeart.b0872172.svg";